module.exports = __webpack_public_path__ + "static/img/42-1.25f6b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/42-1.jpg
// module id = K2+M
// module chunks = 0